export default __webpack_public_path__ + "static/media/billingIcon.d2189caa.svg";